//clear form function
function clearForm (e, formElements) {
  e.preventDefault();

  [...formElements].forEach( el => {
    //inputs
    if( el.tagName == 'INPUT' ){
      el.value = '';
    }
    //select
    if( el.tagName == 'SELECT' ){
      el.selectedIndex = 0;
    }
  })
}

//bind event
if( document.getElementsByTagName('FORM').length > 0 ){
  [...document.getElementsByTagName('FORM')].forEach( formEl => {
    let formElements = formEl.elements;

    [...formElements].forEach( element => {
      if( element.classList.contains('clear-form') ){
        element.addEventListener('click', e => clearForm(e, formElements) );
      }
    })

  })
}
